// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__juVzf","top":"styles_top__3HSDH","left":"styles_left__3yWcy","description":"styles_description__NQCB9"};